import request from '@/utils/request'

/**
 * 查询家政服务工单流转列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool.listHousekeepingServPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}